import type { StepDialogConfig } from './types';

/**
 * Tracks progress through a sequence of dialogs based on their show/hasShown states.
 *
 * @param dialogs - Array of dialog configs in sequence order
 * @returns Progress information:
 *   - totalSteps: Number of dialogs that have ever been shown
 *   - currentStep: Number of consecutive dialogs from the start that have been shown
 *
 * The currentStep only increments when all previous dialogs have been shown,
 * ensuring users complete the steps in order. A dialog contributes to the step
 * count if it is either currently showing or has been shown before.
 */
export const useStepProgress = (dialogs: StepDialogConfig[]) => {
  // Count total number of dialogs that have been shown
  const totalSteps = dialogs.filter(({ state }) => state.hasShown).length;

  // Find first index where dialog has been shown and is currently showing
  const currentStep =
    dialogs.filter(({ state }) => state.hasShown).findIndex(({ state }) => state.hasShown && state.show) + 1;

  return { totalSteps, currentStep };
};
